import { expVal } from '@atlassian/jira-feature-experiments';

const isIssueTableFlatListInitialisationFixEnabledRelayProvider = {
	get(): boolean {
		return expVal('issue_table_flat_list_initialisation_fix', 'isEnabled', false);
	},
};

export default isIssueTableFlatListInitialisationFixEnabledRelayProvider;
